<template>
    <div class="emd-text-section">
      <emd-text
        v-if="title"
        class="emd-text-section__title"
        size="section"
        data-testid="title"
      >
        {{ title }}
      </emd-text>
      <div class="emd-text-section__container" data-testid="slot-content">
        <slot></slot>
      </div>
    </div>
  </template>

<script>
import EmdText from '../../atoms/emdText/EmdText.vue'

export default {
  name: 'EmdTextSection',
  components: {
    EmdText
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

  <style scoped>
  .emd-text-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
  }

  .emd-text-section:last-child {
    margin-bottom: 0;
  }

  .emd-text-section__title {
    font-family: 'Open Sans', sans-serif;
    text-transform: uppercase;
    font-size: 14px;
    margin-bottom: 12px;
  }

  .emd-text-section__container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));
    row-gap: 16px;
    column-gap: 24px;
  }
  </style>
